import { E_AppCustoms } from "@/constants/app";
import { E_PlatformCustoms } from "@/constants/platform";
import { E_MenuItem } from "@/view_helper/menu";
import { filterPermissionMenus, IMenuItem, IMenuItemTop } from "./mainMenu";
import { IUserMenu } from "@/api/moudules/system.types";
import _ from "lodash";
import Vue from "vue";

export const AppCustomsOptions = [
    E_AppCustoms.SPOT_CHECK,
    E_AppCustoms.PLATFORM_REMOTE,
    E_AppCustoms.VIP,
    E_AppCustoms.OEM,
]

export const PlatformCustomOptions = [
    E_PlatformCustoms.TrendAlarm,
    E_PlatformCustoms.FaultDiagnosis,
    E_PlatformCustoms.AiDiagnosis,
    E_PlatformCustoms.SPOT_CHECK,
    E_PlatformCustoms.Full,
]

function removeCompanyAdminMenus(menus: IMenuItem[]): IMenuItem[] {
    return _.flatMap(menus, menu => {
        if (menu.isCompanyAdminMenu) {
            return []
        }
        const children = removeCompanyAdminMenus(menu.children || [])
        return [{
            ...menu,
            children,
        }]
    })
}

export function filterMenus(vm: Vue, isSuperAdmin: boolean, isCompanyAdmin: boolean, menus: IMenuItemTop[], gMenus: IUserMenu[]) {
    if (isSuperAdmin) {
        return _.filter(menus, menu => {
            return menu.isSuperAdminMenu
        })
    }
    const menusRest = _.filter(menus, menu => {
        return !menu.isSuperAdminMenu
    })
    const permissionMenus = filterPermissionMenus(vm, removeCompanyAdminMenus(menusRest), gMenus)
    if (!isCompanyAdmin) {
        return permissionMenus
    }
    return filterPermissionMenus(vm, menusRest, gMenus)
}
